export function resolveAcervoCreatedDestination({
  objective,
  createdId,
}: {
  objective?: string | null;
  createdId?: string;
}): string {
  if (objective === 'own_brand') {
    return createdId ? `/project/${createdId}/edit` : '/projects';
  }
  return '/library';
}
